module.exports = "li {\n  border-bottom: 1px solid grey;\n  margin-bottom: 20px;\n}\n\nbutton:not(.link) {\n  margin: 20px;\n}\n"